const PUBLIC_LINK = 'public_link'
const PRIVATE_ACCESS = 'private_access'
const TWO_FACTOR_EMAIL = 'two_factor_email'
const TWO_FACTOR_PHONE = 'two_factor_phone'

const DIGITS_COUNT = 6
const RESEND_SECONDS = 15

const ACCESS_TYPES = {
  PUBLIC_LINK,
  PRIVATE_ACCESS,
}

const LOGIN_MODES = {
  TWO_FACTOR_EMAIL,
  TWO_FACTOR_PHONE,
}

const courseAccess = {
  ACCESS_TYPES,
  LOGIN_MODES,
  DIGITS_COUNT,
  RESEND_SECONDS,
}

export default courseAccess
